<button class="btn text-primary-800 shadow border-plantation bg-white px-4 hover:bg-plantation hover:text-white" (click)="toggle()">
    <fa-icon [icon]="bars" size="2x"></fa-icon>
</button>
